export enum Status {
  Current = 'current',
  Ignored = 'ignored',
  New = 'new'
}

export let statusNameMapper: Record<Status, string> = {
  [Status.Current]: 'Current',
  [Status.Ignored]: 'Ignored',
  [Status.New]: 'New'
}
